import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import category from './category/categorySlice'
import upload from "./upload"
import profile from "./profile"
import menuCount from "./menuCount/menuCountSlice"
const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        category,
        upload,
        profile,
        menuCount,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
